import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useContext,
  useCallback,
} from "react";
// import {  useDispatch } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import { actlistData, actmore } from "../../actions/index";
import Navigationtitle from "../include/Navigationtitle";
import { IoColorPaletteOutline } from "react-icons/io5";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import DataService from ".././../services/tutorial.service";
import {
  getDatabase,
  ref,
  remove,
  push,
  onValue,
  set,
  off,
  update,
} from "firebase/database";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faL, faShareNodes } from "@fortawesome/free-solid-svg-icons";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { faExpand } from "@fortawesome/free-solid-svg-icons";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { confirmAlert } from "react-confirm-alert";
import { gif1, gif2, gif3, gif4, hexagon } from "../../constants/Images";
import { useSelector, useDispatch } from "react-redux";
import { BsLayoutWtf } from "react-icons/bs";
import { PiSelectionBackgroundFill } from "react-icons/pi";
import { TbListDetails } from "react-icons/tb";
import { MdOutlineSettingsBackupRestore } from "react-icons/md";
// import { color } from 'html2canvas/dist/types/css/types/color';
import { CiImport } from "react-icons/ci";
import playerimg from "../../assets/img/photo1.jpg";
import bgvideo from "../../assets/img/plovbg.mp4";
import teamlogo from "../../assets/img/im logo.jpg";
import { ovtheme1, ovtheme2, ovtheme3, ovtheme4 } from "../../constants/Images";
import "../../assets/css/strip.css";
import "../../assets/css/player.css";
import { FaChevronRight } from "react-icons/fa6";
import { FaChevronDown } from "react-icons/fa";

import { MdOutlineRefresh } from "react-icons/md";

export default function AuctionCustomization(match) {
  const dispatch = useDispatch();

  const loginuser = useSelector((state) => state.setUserlog);

  const aucmoredetail = useSelector((state) => state.actmoredata);
  const [aucdetail, setaucdetail] = useState(aucmoredetail);
  const [aucback, setaucback] = useState("");
  const [selectedOption, setSelectedOption] = useState("0");

  const [aucbackbox, setaucbackbox] = useState("");
  const [aucstampbox, setaucstampbox] = useState("");
  const [aucustampbox, setaucustampbox] = useState("");
  const [aucsoldstamp, setaucsoldstamp] = useState("");
  const [aucunsoldstamp, setaucunsoldstamp] = useState("");
  const [aucsponsorbox, setaucsponsorbox] = useState("");
  const [aucbannerbox, setaucbannerbox] = useState("");
  const [aucsponsor, setaucsponsor] = useState("");
  const [aucbanner, setaucbanner] = useState("");
  const [isimgpop, setisimgpop] = useState(false);
  const [imgpopdata, setimgpopdata] = useState([]);
  const [imgpoptype, setimgpoptype] = useState("");
  const [isbgpop, setisbgpop] = useState(false);
  const [bgdata, setbgdata] = useState([]);
  const [isfullbg, setisfullbg] = useState(false);
  const [selectedbgfl, setselectedbgfl] = useState("");
  const [bgfulldata, setbgfulldata] = useState("");

  const [isActive, setActive] = useState(false);
  const [cid, setCid] = useState(loginuser["cid"]);
  const [customtype, setcustomtype] = useState("theme");
  const [primarycolor, setprimarycolor] = useState("#0a1c41");
  const [secondarycolor, setsecondarycolor] = useState("#00ffdf");
  const [primaryfontcolor, setprimaryfontcolor] = useState("#002236");
  const [secondaryfontcolor, setsecondaryfontcolor] = useState("#ffffff");
  const [tertiarycolor, settertiarycolor] = useState("#002236");
  const [tertiaryfontcolor, settertiaryfontcolor] = useState("#ffffff");
  const [primarycolor_gc1, setprimarycolor_gc1] = useState("");
  const [primarycolor_gc2, setprimarycolor_gc2] = useState("");
  const [sc1_sec1_gc1, setsc1_sec1_gc1] = useState("#1b1842");
  const [sc1_sec1_gc2, setsc1_sec1_gc2] = useState("#242160");
  const [sc1_sec1_gc3, setsc1_sec1_gc3] = useState("#770c77");
  const [sc1_sec2, setsc1_sec2] = useState("#1b1842");

  const [sc1_pldetail_gc1, setsc1_pldetail_gc1] = useState("#1b1842");
  const [sc1_pldetail_gc2, setsc1_pldetail_gc2] = useState("#0c147e");
  const [sc1_pldetail_gc3, setsc1_pldetail_gc3] = useState("#1b1842");
  const [sc1_crbid_bg1, setsc1_crbid_bg1] = useState("#a3c9d6");
  const [sc1_crbid_bg2, setsc1_crbid_bg2] = useState("#4389a5");
  const [sc1_crbid_bg3, setsc1_crbid_bg3] = useState("#4eafd6");
  const [sc1_plborder, setsc1_plborder] = useState("#d3c366");
  const [sc1_plno_bg, setsc1_plno_bg] = useState("#383892");
  const [sc1_plno_font, setsc1_plno_font] = useState("#eebbc4");
  const [sc1_plnm_font, setsc1_plnm_font] = useState("#6ad6d1");
  const [sc1_bid_font, setsc1_bid_font] = useState("#0b0b36");
  const [sc2_primary_bg, setsc2_primary_bg] = useState("#4e1a80");
  const [sc2_crbid_bg, setsc2_crbid_bg] = useState("#dbd6e0");
  const [sc2_tbHead_bg, setsc2_tbHead_bg] = useState("#b8f1f1");
  const [sc2_tbOdd_bg, setsc2_tbOdd_bg] = useState("#1b1ba0");
  const [sc2_tbEven_bg, setsc2_tbEven_bg] = useState("#ffffff");
  const [sc2_plno_nm_font, setsc2_plno_nm_font] = useState("#ffff00");
  const [sc2_crbid_font, setsc2_crbid_font] = useState("#4e1a80");
  const [sc2_tbHead_row_font, setsc2_tbHead_row_font] = useState("#262696");
  const [sc2_plborder, setsc2_plborder] = useState("#0000ff");
  //   const [primarycolor_sec2_1, setprimarycolor_sec2_2] = useState("");

  const [isClicked, setisClicked] = useState(false);
  const [activeDrawer, setActiveDrawer] = useState(null);
  const [Custom, setCustom] = useState({});
  const [selectedTheme, setSelectedTheme] = useState(null);
  const [themeColors, setThemeColors] = useState({});

  const [theme, setTheme] = useState(1);
  const [themecheck, setThemecheck] = useState(2);

  const [isInitialLoad, setIsInitialLoad] = useState(true);
  // const [currentIndex, setCurrentIndex] = useState(0);
  const [activeScreen, setActiveScreen] = useState("screen2");

  const aid = localStorage.getItem("auction_id");
  const updtoken = useSelector((state) => state.updtoken);

  const history = useHistory({ forceRefresh: true });

  const fileInputRefs = useRef(
    Array.from({ length: 8 }, () => React.createRef())
  );

  // const images = [
  //     "playerbiotheme.png = Image + 1",
  //     "striptheme.png = Image + 2"
  // ];

  //   useEffect = (() => {
  //     const interval = setInterval(() => {
  //         setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length)
  //     }, 2000);

  //     return () => clearInterval(interval);

  //   },[])

  const isAdmin = localStorage.getItem("admin_id") !== null;

  const [overlayUrl, setOverlayUrl] = useState(`https://superplayerauction.com/ov/index?actid=${aid}`);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(overlayUrl).then(() => {
      toast.success("Overlay link copied to clipboard!", { 
        theme: "colored",
        position: "bottom-center",
        autoClose: 2000
      });
    });
  };

  const toggleDrawer = (drawer) => {
    setActiveDrawer(activeDrawer === drawer ? null : drawer);
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const [defaultThemeData, setDefaultThemeData] = useState({});

  const defaultset = (forceDefault = false) => {
    console.log("defaultset");
    // Default values for content section
    var themeData = {};

    if (
      !forceDefault &&
      aucmoredetail.ov_custom &&
      aucmoredetail.ov_theme == theme
    ) {
      console.log("called..........");
      themeData = aucmoredetail.ov_custom;
    } else {
      if (theme == 1) {
        themeData = {
          primarycolor: "#0a1c41",
          secondarycolor: "#00ffdf",
          tertiarycolor: "#082842",
          primarycolor_gc1: "",
          primarycolor_gc2: "",
          primaryfontcolor: "#002236",
          secondaryfontcolor: "#ffffff",
          tertiaryfontcolor: "#ffffff",
        };
      } else if (theme == 2) {
        console.log("theme 2");
        themeData = {
          primarycolor: "",
          primarycolor_gc1: "#0c1b37",
          primarycolor_gc2: "#7081ae",
          secondarycolor: "#55abc8",
          tertiarycolor: "",
          primaryfontcolor: "#ffffff",
          secondaryfontcolor: "#ffffff",
          tertiaryfontcolor: "",
        };
      } else if (theme == 3) {
        themeData = {
          sc1_sec1_gc1: "#1b1842",
          sc1_sec1_gc2: "#242160",
          sc1_sec1_gc3: "#770c77",
          sc1_sec2: "#1b1842",
          sc1_plno_bg: "#383892",
          sc1_pldetail_gc1: "#1b1842",
          sc1_pldetail_gc2: "#0c147e",
          sc1_pldetail_gc3: "#1b1842",
          sc1_crbid_bg1: "#a3c9d6",
          sc1_crbid_bg2: "#4389a5",
          sc1_crbid_bg3: "#4eafd6",
          sc1_plborder: "#d3c366",
          sc1_plno_font: "#eebbc4",
          sc1_plnm_font: "#6ad6d1",
          sc1_bid_font: "#0b0b36",
          primaryfontcolor: "#ffffff",

          sc2_primary_bg: "#4e1a80",
          sc2_plborder: "#0000ff",
          sc2_crbid_bg: "#dbd6e0",
          sc2_tbHead_bg: "#b8f1f1",
          sc2_tbOdd_bg: "#1b1ba0",
          sc2_tbEven_bg: "#ffffff",
          sc2_plno_nm_font: "#ffff00",
          sc2_crbid_font: "#4e1a80",
          sc2_tbHead_row_font: "#262696",
        };
      }
    }

    setDefaultThemeData(themeData);

    // Set the default colors

    setprimarycolor(themeData.primarycolor);
    setsecondarycolor(themeData.secondarycolor);
    setprimaryfontcolor(themeData.primaryfontcolor);
    setsecondaryfontcolor(themeData.secondaryfontcolor);
    setprimarycolor_gc1(themeData.primarycolor_gc1);
    setprimarycolor_gc2(themeData.primarycolor_gc2);

    setsc1_sec1_gc1(themeData.sc1_sec1_gc1);
    setsc1_sec1_gc2(themeData.sc1_sec1_gc2);
    setsc1_sec1_gc3(themeData.sc1_sec1_gc3);
    setsc1_sec2(themeData.sc1_sec2);
    setsc1_plno_bg(themeData.sc1_plno_bg);
    setsc1_pldetail_gc1(themeData.sc1_pldetail_gc1);
    setsc1_pldetail_gc2(themeData.sc1_pldetail_gc2);
    setsc1_pldetail_gc3(themeData.sc1_pldetail_gc3);
    setsc1_crbid_bg1(themeData.sc1_crbid_bg1);
    setsc1_crbid_bg2(themeData.sc1_crbid_bg2);
    setsc1_crbid_bg3(themeData.sc1_crbid_bg3);
    setsc1_plborder(themeData.sc1_plborder);
    setsc1_plno_font(themeData.sc1_plno_font);
    setsc1_plnm_font(themeData.sc1_plnm_font);
    setsc1_bid_font(themeData.sc1_bid_font);

    setsc2_primary_bg(themeData.sc2_primary_bg);
    setsc2_plborder(themeData.sc2_plborder);
    setsc2_crbid_bg(themeData.sc2_crbid_bg);
    setsc2_tbHead_bg(themeData.sc2_tbHead_bg);
    setsc2_tbOdd_bg(themeData.sc2_tbOdd_bg);
    setsc2_tbEven_bg(themeData.sc2_tbEven_bg);
    setsc2_plno_nm_font(themeData.sc2_plno_nm_font);
    setsc2_crbid_font(themeData.sc2_crbid_font);
    setsc2_tbHead_row_font(themeData.sc2_tbHead_row_font);
  };

  // useEffect(() => {
  //   defaultset();
  // }, [theme]);

  const [themeInitialized, setThemeInitialized] = useState(false);

  useEffect(() => {
    defaultset();
    setThemeInitialized(true);
  }, [theme]);

  const [hoveredSection, setHoveredSection] = useState(null);

  const handleResetColors = (key) => {
    if (!defaultThemeData) return;

    switch (key) {
      case "th1_primecolor": {
        setprimarycolor(defaultThemeData.primarycolor);
        break;
      }
      case "th2_primecolor": {
        setprimarycolor_gc1(defaultThemeData.primarycolor_gc1);
        setprimarycolor_gc2(defaultThemeData.primarycolor_gc2);
        break;
      }
      case "sec_color": {
        setsecondarycolor(defaultThemeData.secondarycolor);
        break;
      }
      case "tertiary_color": {
        settertiarycolor(defaultThemeData.secondarycolor);
        break;
      }
      case "primefont_color": {
        setprimaryfontcolor(defaultThemeData.primaryfontcolor);
        break;
      }
      case "secfont_color": {
        setsecondaryfontcolor(defaultThemeData.secondaryfontcolor);
        break;
      }
      case "tertiaryfont_color": {
        settertiaryfontcolor(defaultThemeData.tertiaryfontcolor);
        break;
      }

      case "sc1_sec1": {
        setsc1_sec1_gc1(defaultThemeData.sc1_sec1_gc1);
        setsc1_sec1_gc2(defaultThemeData.sc1_sec1_gc2);
        setsc1_sec1_gc3(defaultThemeData.sc1_sec1_gc3);
        break;
      }
      case "sc1_sec2": {
        setsc1_sec2(defaultThemeData.sc1_sec2);
        break;
      }
      case "sc1_plno": {
        setsc1_plno_bg(defaultThemeData.sc1_plno_bg);
        break;
      }
      case "sc1_pldetail": {
        setsc1_pldetail_gc1(defaultThemeData.sc1_pldetail_gc1);
        setsc1_pldetail_gc2(defaultThemeData.sc1_pldetail_gc2);
        setsc1_pldetail_gc3(defaultThemeData.sc1_pldetail_gc3);
        break;
      }
      case "sc1_crbid": {
        setsc1_crbid_bg1(defaultThemeData.sc1_crbid_bg1);
        setsc1_crbid_bg2(defaultThemeData.sc1_crbid_bg2);
        setsc1_crbid_bg3(defaultThemeData.sc1_crbid_bg3);
        break;
      }
      case "sc1_plborder": {
        setsc1_plborder(defaultThemeData.sc1_plborder);
        break;
      }
      case "sc1_plnofont": {
        setsc1_plno_font(defaultThemeData.sc1_plno_font);
        break;
      }
      case "sc1_plnmfont": {
        setsc1_plnm_font(defaultThemeData.sc1_plnm_font);
        break;
      }
      case "sc1_bidfont": {
        setsc1_bid_font(defaultThemeData.sc1_bid_font);
        break;
      }

      case "sc2_primary": {
        setsc2_primary_bg(defaultThemeData.sc2_primary_bg);
        break;
      }
      case "sc2_plborder": {
        setsc2_plborder(defaultThemeData.sc2_plborder);
        break;
      }
      case "sc2_crbid": {
        setsc2_crbid_bg(defaultThemeData.sc2_crbid_bg);
        break;
      }
      case "sc2_tbhead": {
        setsc2_tbHead_bg(defaultThemeData.sc2_tbHead_bg);
        break;
      }
      case "sc2_tboddrow": {
        setsc2_tbOdd_bg(defaultThemeData.sc2_tbOdd_bg);
        break;
      }
      case "sc2_tbevenrow": {
        setsc2_tbEven_bg(defaultThemeData.sc2_tbEven_bg);
        break;
      }
      case "sc2_plno_nmfont": {
        setsc2_plno_nm_font(defaultThemeData.sc2_plno_nm_font);
        break;
      }
      case "sc2_crbidfont": {
        setsc2_crbid_font(defaultThemeData.sc2_crbid_font);
        break;
      }
      case "sc2_tbhead_rowfont": {
        setsc2_tbHead_row_font(defaultThemeData.sc2_tbHead_row_font);
        break;
      }

      default:
        break;
    }
  };

  useEffect(() => {
    //   if (aucmoredetail.more) {
    //       if (aucmoredetail.more[0].bg != "" && aucmoredetail.more[0].bg != null) {
    //   setaucbackbox(aucmoredetail.fpath + aucmoredetail.more[0].bg);
    // }

    // if (
    //   aucmoredetail.more[0].sstamp != "" &&
    //   aucmoredetail.more[0].sstamp != null
    // ) {
    //   setaucstampbox(aucmoredetail.fpath + aucmoredetail.more[0].sstamp);
    // }
    // if (
    //   aucmoredetail.more[0].fireworks != "" &&
    //   aucmoredetail.more[0].fireworks != null
    // ) {
    //   setSelectedOption(aucmoredetail.more[0].fireworks);
    // }
    // if (
    //   aucmoredetail.more[0].usstamp != "" &&
    //   aucmoredetail.more[0].usstamp != null
    // ) {
    //   setaucustampbox(aucmoredetail.fpath + aucmoredetail.more[0].usstamp);
    // }
    // Set initial theme from API data
    console.log("auc detail is..");
    console.log(aucmoredetail);
    if (aucmoredetail.ov_theme) {
      console.log("ov theme is .........");
      console.log(aucmoredetail);
      console.log(aucmoredetail.ov_theme);
      setTheme(parseInt(aucmoredetail.ov_theme));
      setThemecheck(parseInt(aucmoredetail.ov_theme));
    }
    if (aucmoredetail.ov_custom) {
      const thData = aucmoredetail.ov_custom;
      setprimarycolor(thData.primarycolor);
      setsecondarycolor(thData.secondarycolor);
      setprimaryfontcolor(thData.primaryfontcolor);
      setsecondaryfontcolor(thData.secondaryfontcolor);
      setprimarycolor_gc1(thData.primarycolor_gc1);
      setprimarycolor_gc2(thData.primarycolor_gc2);

      setsc1_sec1_gc1(thData.sc1_sec1_gc1);
      setsc1_sec1_gc2(thData.sc1_sec1_gc2);
      setsc1_sec1_gc3(thData.sc1_sec1_gc3);
      setsc1_sec2(thData.sc1_sec2);

      setsc1_plno_bg(thData.sc1_plno_bg);
      setsc1_pldetail_gc1(thData.sc1_pldetail_gc1);
      setsc1_pldetail_gc2(thData.sc1_pldetail_gc2);
      setsc1_pldetail_gc3(thData.sc1_pldetail_gc3);
      setsc1_crbid_bg1(thData.sc1_crbid_bg1);
      setsc1_crbid_bg2(thData.sc1_crbid_bg2);
      setsc1_crbid_bg3(thData.sc1_crbid_bg3);
      setsc1_plborder(thData.sc1_plborder);
      setsc1_plno_font(thData.sc1_plno_font);
      setsc1_plnm_font(thData.sc1_plnm_font);
      setsc1_bid_font(thData.sc1_bid_font);
      setsc2_primary_bg(thData.sc2_primary_bg);
      setsc2_plborder(thData.sc2_plborder);
      setsc2_crbid_bg(thData.sc2_crbid_bg);
      setsc2_tbHead_bg(thData.sc2_tbHead_bg);
      setsc2_tbOdd_bg(thData.sc2_tbOdd_bg);
      setsc2_tbEven_bg(thData.sc2_tbEven_bg);
      setsc2_plno_nm_font(thData.sc2_plno_nm_font);
      setsc2_crbid_font(thData.sc2_crbid_font);
      setsc2_tbHead_row_font(thData.sc2_tbHead_row_font);
      setIsInitialLoad(false);
    }
  }, [aucmoredetail]);

  useEffect(() => {
    if (mythemes[2].img2) {
      const interval = setInterval(() => {
        setCurrentImg((prev) =>
          prev === mythemes[2].img ? mythemes[2].img2 : mythemes[2].img
        );
      }, 3000);
      return () => clearInterval(interval);
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    const isFirstMount = localStorage.getItem("isFirstMount");
    //  console.log('isFirstMount')
    //  console.log(isFirstMount)
    if (!isFirstMount) {
      //  console.log('setting false')
      localStorage.setItem("isFirstMount", false);
    } else {
      //  console.log('going back....')

      localStorage.removeItem("isFirstMount");
      // history.push('/auction-detail');
    }
  }, [history]);

  const handleFileChange = (e, t) => {
    const file = e.target.files[0];
    if (t == "1") {
      setaucback(file);
    } else if (t == "2") {
      setaucsoldstamp(file);
    } else if (t == "3") {
      setaucunsoldstamp(file);
    } else if (t == "4") {
      setaucsponsor(file);
    } else if (t == "5") {
      setaucbanner(file);
    }
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        if (t == "1") {
          setaucbackbox(event.target.result);
        } else if (t == "2") {
          setaucstampbox(event.target.result);
        } else if (t == "3") {
          setaucustampbox(event.target.result);
        } else if (t == "4") {
          setaucsponsorbox(event.target.result);
        } else if (t == "5") {
          setaucbannerbox(event.target.result);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const removefile = async (imgpoptype) => {
    if (imgpoptype == "3" || imgpoptype == "4" || imgpoptype == "5") {
      setActive(true);
      const id = toast.loading("Please wait...");

      let toastContainerId = toast.update(id, {
        render: "please wait...",
        theme: "dark",
        position: "bottom-center",
      });
      var hdr = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: JSON.stringify([
            { cid: cid, aid: aid, token: loginuser["token"] },
          ]),
        },
      };
      var vals = {};

      if (imgpoptype == "3") {
        vals.fltyp = "bg";
      } else if (imgpoptype == "4") {
        vals.fltyp = "sstamp";
      } else if (imgpoptype == "5") {
        vals.fltyp = "usstamp";
      }
      await DataService.delfiles(vals, hdr)
        .then((res) => {
          let response = res.data;
          toast.dismiss(toastContainerId);

          if (response.success == true) {
            setisimgpop(false);
            if (imgpoptype == "3") {
              setaucdetail((detail) => ({
                ...detail,
                more: [{ ...detail.more[0], bg: "" }],
              }));
            } else if (imgpoptype == "4") {
              setaucdetail((detail) => ({
                ...detail,
                more: [{ ...detail.more[0], sstamp: "" }],
              }));
            } else if (imgpoptype == "5") {
              setaucdetail((detail) => ({
                ...detail,
                more: [{ ...detail.more[0], usstamp: "" }],
              }));
            }
            toast.success("Removed !!", {
              theme: "colored",
              position: "bottom-center",
            });
          } else {
            if (response.msg != "")
              toast.error(response.msg, { theme: "colored" });
          }

          setActive(false);
        })
        .catch(() => {
          //  console.log("Not valid");
          toast.error("Not valid Server Error", { theme: "colored" });
          setActive(false);
        });
    } else if (imgpoptype == "2") {
      setActive(true);
      const id = toast.loading("Please wait...");

      let toastContainerId = toast.update(id, {
        render: "please wait...",
        theme: "dark",
        position: "bottom-center",
      });
      var hdr = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: JSON.stringify([
            { cid: cid, aid: aid, token: loginuser["token"] },
          ]),
        },
      };
      var vals = {};
      vals.i = imgpopdata.spnid;

      await DataService.delspn(vals, hdr)
        .then((res) => {
          let response = res.data;
          toast.dismiss(toastContainerId);
          if (response.success == true) {
            const db = getDatabase();
            set(ref(db, "map/info/" + aid), {
              type: "1",
              upd: "6",
              id: aid,
              detail: {
                typ: 14,
                upd: 2,
                val: imgpopdata.spnid,
              },
              tkn: updtoken,
            });
            setisimgpop(false);
            setaucdetail((detail) => ({
              ...detail,
              spn: detail.spn.filter((sp) => sp.spnid != imgpopdata.spnid),
            }));
            toast.success("Removed !!", {
              theme: "colored",
              position: "bottom-center",
            });
          } else {
            if (response.msg != "")
              toast.error(response.msg, { theme: "colored" });
          }

          setActive(false);
        })
        .catch(() => {
          //  console.log("Not valid");
          toast.error("Not valid Server Error", { theme: "colored" });
          setActive(false);
        });
    } else if (imgpoptype == "1") {
      setActive(true);
      const id = toast.loading("Please wait...");

      let toastContainerId = toast.update(id, {
        render: "please wait...",
        theme: "dark",
        position: "bottom-center",
      });
      var hdr = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: JSON.stringify([
            { cid: cid, aid: aid, token: loginuser["token"] },
          ]),
        },
      };
      var vals = {};
      vals.i = imgpopdata.bnrid;

      await DataService.delbnr(vals, hdr)
        .then((res) => {
          let response = res.data;
          toast.dismiss(toastContainerId);
          if (response.success == true) {
            const db = getDatabase();
            set(ref(db, "map/info/" + aid), {
              type: "1",
              upd: "6",
              id: aid,
              detail: {
                typ: 15,
                upd: 2,
                val: { id: imgpopdata.bnrid },
              },
              tkn: updtoken,
            });
            setisimgpop(false);
            setaucdetail((detail) => ({
              ...detail,
              bnr: detail.bnr.filter((bn) => bn.bnrid != imgpopdata.bnrid),
            }));
            toast.success("Removed !!", {
              theme: "colored",
              position: "bottom-center",
            });
          } else {
            if (response.msg != "")
              toast.error(response.msg, { theme: "colored" });
          }

          setActive(false);
        })
        .catch(() => {
          //  console.log("Not valid");
          toast.error("Not valid Server Error", { theme: "colored" });
          setActive(false);
        });
    }
  };

  const removeuploads = async (t) => {
    setActive(true);
    const id = toast.loading("Please wait...");

    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    var vals = {};
    if (t == "1") {
      vals.fltyp = "bg";
    } else if (t == "2") {
      vals.fltyp = "sstamp";
    } else if (t == "3") {
      vals.fltyp = "usstamp";
    }
    await DataService.delfiles(vals, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);

        if (response.success == true) {
          setisimgpop(false);
          if (t == "1") {
            setaucbackbox("");
            setaucdetail((detail) => ({
              ...detail,
              more: [{ ...detail.more[0], bg: "" }],
            }));
            const db = getDatabase();
            set(ref(db, "map/info/" + aid), {
              type: "1",
              upd: "6",
              id: aid,
              detail: {
                typ: 13,
                upd: 2,
                val: "",
              },
              tkn: updtoken,
            });
          } else if (t == "2") {
            setaucstampbox("");
            setaucdetail((detail) => ({
              ...detail,
              more: [{ ...detail.more[0], sstamp: "" }],
            }));
          } else if (t == "3") {
            setaucustampbox("");
            setaucdetail((detail) => ({
              ...detail,
              more: [{ ...detail.more[0], usstamp: "" }],
            }));
          }
          toast.success("Removed !!", {
            theme: "colored",
            position: "bottom-center",
          });
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  const delfile = (t) => {
    confirmAlert({
      message: "Are you sure delete this record !",
      buttons: [
        {
          label: "Yes",
          onClick: () => removeuploads(t),
        },
        {
          label: "No",
          // onClick: () => del(id, 0),
        },
      ],
    });
  };

  const themesubmit = async (theme) => {
    setActive(true);
    const id = toast.loading("Please wait...");

    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });
    //  console.log('aid')
    //  console.log(aid)
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };

    var themeval = {};
    themeval = aucmoredetail.ov_custom;
    var vals = { bs: "1", ms: "2" };
    // vals.bg = themebg.substring(themebg.lastIndexOf('/') + 1)
    vals.theme = theme;
    vals.custom = {
      primarycolor: primarycolor,
      secondarycolor: secondarycolor,
      primarycolor_gc1: primarycolor_gc1,
      primarycolor_gc2: primarycolor_gc2,
      // Theme 3
      sc1_sec1_gc1: sc1_sec1_gc1,
      sc1_sec1_gc2: sc1_sec1_gc2,
      sc1_sec1_gc3: sc1_sec1_gc3,
      sc1_sec2: sc1_sec2,
      sc1_plno_bg: sc1_plno_bg,
      sc1_pldetail_gc1: sc1_pldetail_gc1,
      sc1_pldetail_gc2: sc1_pldetail_gc2,
      sc1_pldetail_gc3: sc1_pldetail_gc3,
      sc1_crbid_bg1: sc1_crbid_bg1,
      sc1_crbid_bg2: sc1_crbid_bg2,
      sc1_crbid_bg3: sc1_crbid_bg3,
      sc1_plborder: sc1_plborder,
      sc1_plno_font: sc1_plno_font,
      sc1_plnm_font: sc1_plnm_font,
      sc1_bid_font: sc1_bid_font,
      sc2_primary_bg: sc2_primary_bg,
      sc2_plno_nm_font: sc2_plno_nm_font,
      sc2_plborder: sc2_plborder,
      sc2_crbid_font: sc2_crbid_font,
      sc2_crbid_bg: sc2_crbid_bg,
      sc2_tbHead_bg: sc2_tbHead_bg,
      sc2_tbOdd_bg: sc2_tbOdd_bg,
      sc2_tbEven_bg: sc2_tbEven_bg,
      sc2_tbHead_row_font: sc2_tbHead_row_font,

      //  Font of theme 1/theme 2
      primaryfont: primaryfontcolor,
      secondaryfont: secondaryfontcolor,
      tertiarycolor: tertiarycolor,
      tertiaryfont: tertiaryfontcolor,
    };
    console.log("vals..........");
    console.log(vals.custom);

    // vals.custom = {
    //     colors: {
    //         title_c: color,
    //         bid_c: color2,
    //         pl_name_dt_c: color3,
    //         border_c: color4,
    //         team_C: color5,
    //         pl_head_gc1: color6,
    //         pl_head_gc2: color7,
    //         pl_border_c: color8,
    //         pl_shadow_c: color9,
    //         pl_detail_bg_gc1: color10,
    //         pl_detail_bg_gc2: color11,
    //         pl_dt_shadow_c: color12,
    //         extra_dt_c: color13,
    //         mp_label_c: color14,
    //         mp_val_c: color15,
    //         pl_border_gc1: color16,
    //         pl_border_gc2: color17,
    //         mp_bg_gc1: color18,
    //         mp_bg_gc2: color19

    //     },

        await DataService.setovtheme(vals, hdr)
            .then((res) => {
                let response = res.data;
        console.log("theme submit response");
        console.log(response);
                //  console.log(vals)
                toast.dismiss(toastContainerId);
                if (response.success == true) {
                    // var auccopy = aucdetail
                    // auccopy.more[0].theme = theme
                    // auccopy.more[0].bg = themebg
                    // auccopy.custom = vals.custom
                    // dispatch(actmore(auccopy));

          toast.success("Effect set !!", {
            theme: "colored",
            position: "bottom-center",
          });
          // setaucbackbox(bgdata.path + selectedbgfl);

          // Apply new colors
          setprimarycolor(vals.custom.primarycolor);
          setsecondarycolor(vals.custom.secondarycolor);
          setprimaryfontcolor(vals.custom.primaryfontcolor);
          setsecondaryfontcolor(vals.custom.secondaryfontcolor);
          setprimarycolor_gc1(vals.custom.primarycolor_gc1);
          setprimarycolor_gc2(vals.custom.primarycolor_gc2);

          setsc1_sec1_gc1(vals.custom.sc1_sec1_gc1);
          setsc1_sec1_gc2(vals.custom.sc1_sec1_gc2);
          setsc1_sec1_gc3(vals.custom.sc1_sec1_gc3);
          setsc1_sec2(vals.custom.sc1_sec2);
          setsc1_plno_bg(vals.custom.sc1_plno_bg);
          setsc1_pldetail_gc1(vals.custom.sc1_pldetail_gc1);
          setsc1_pldetail_gc2(vals.custom.sc1_pldetail_gc2);
          setsc1_pldetail_gc3(vals.custom.sc1_pldetail_gc3);
          setsc1_crbid_bg1(vals.custom.sc1_crbid_bg1);
          setsc1_crbid_bg2(vals.custom.sc1_crbid_bg2);
          setsc1_crbid_bg3(vals.custom.sc1_crbid_bg3);
          setsc1_plborder(vals.custom.sc1_plborder);
          setsc1_plno_font(vals.custom.sc1_plno_font);
          setsc1_plnm_font(vals.custom.sc1_plnm_font);
          setsc1_bid_font(vals.custom.sc1_bid_font);

          setsc2_primary_bg(vals.custom.sc2_primary_bg);
          setsc2_plborder(vals.custom.sc2_plborder);
          setsc2_crbid_bg(vals.custom.sc2_crbid_bg);
          setsc2_tbHead_bg(vals.custom.sc2_tbHead_bg);
          setsc2_tbOdd_bg(vals.custom.sc2_tbOdd_bg);
          setsc2_tbEven_bg(vals.custom.sc2_tbEven_bg);
          setsc2_plno_nm_font(vals.custom.sc2_plno_nm_font);
          setsc2_crbid_font(vals.custom.sc2_crbid_font);
          setsc2_tbHead_row_font(vals.custom.sc2_tbHead_row_font);
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

                setActive(false);
            })
            .catch(() => {
                //  console.log("Not valid");
                toast.error("Not valid Server Error", { theme: "colored" });
                setActive(false);
            });
  };

  function showfullbg(ele) {
    setisfullbg(true);
    setbgfulldata(ele);
  }
  function handleDivClick(fl) {
    setselectedbgfl(fl);
  }
  const setfireworkeffect = async () => {
    setActive(true);
    const id = toast.loading("Please wait...");

    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    var vals = {};
    // vals.fltyp = 'bg';
    vals.fireworks = selectedOption;
    await DataService.setfirework(vals, hdr)
      .then((res) => {
        let response = res.data;
        //  console.log('firework response')
        //  console.log(response)
        //  console.log(vals)
        toast.dismiss(toastContainerId);
        if (response.success == true) {
          setaucdetail((detail) => ({
            ...detail,
            more: [{ ...detail.more[0], fireworks: selectedOption }],
          }));

          var auccopy = aucdetail;
          auccopy.more[0].fireworks = selectedOption;
          dispatch(actmore(auccopy));
          // const db = getDatabase();
          // set(ref(db, 'map/info/' + aid), {
          //   "type": "1", "upd": "6", 'id': aid, "detail": {
          //     "typ": 13,
          //     "upd": 1,
          //     "val": { img: response.data.newentry.logo },
          //   }, "tkn": updtoken
          // });
          // setisbgpop(false)
          // setselectedbgfl("")

          toast.success("Effect set !!", {
            theme: "colored",
            position: "bottom-center",
          });
          // setaucbackbox(bgdata.path + selectedbgfl)
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  const setbg = async () => {
    setActive(true);
    const id = toast.loading("Please wait...");

    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    var vals = {};
    vals.fltyp = "bg";
    vals.fl = selectedbgfl;
    await DataService.setbg(vals, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);
        if (response.success == true) {
          const db = getDatabase();
          set(ref(db, "map/info/" + aid), {
            type: "1",
            upd: "6",
            id: aid,
            detail: {
              typ: 13,
              upd: 1,
              val: { img: response.data.newentry.logo },
            },
            tkn: updtoken,
          });
          setisbgpop(false);
          setselectedbgfl("");

          toast.success("Background set !!", {
            theme: "colored",
            position: "bottom-center",
          });
          setaucbackbox(bgdata.path + selectedbgfl);
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  const banneradd = async () => {
    setActive(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });

    var hdr = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    const formData = new FormData();
    formData.append("bnrimg", aucbanner);

    await DataService.addbanner(formData, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);
        // //  console.log(response)
        if (response.success == true) {
          const db = getDatabase();
          set(ref(db, "map/info/" + aid), {
            type: "1",
            upd: "6",
            id: aid,
            detail: {
              typ: 15,
              upd: 1,
              val: response.data.newentry,
            },
            tkn: updtoken,
          });
          setaucbannerbox("");
          fileInputRefs.current.forEach((ref) => {
            if (ref.current) {
              ref.current.value = "";
            }
          });
          setaucdetail((prev) => ({
            ...prev,
            bnr: [...prev.bnr, response.data.newentry],
          }));
          // //  console.log("setted")
          toast.success("Banner Added !!", {
            theme: "colored",
            position: "bottom-center",
          });

          setaucbanner("");
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  const handleImportClick = () => {
    document.getElementById("fileInputt").click();
  };
  const sponsoradd = async () => {
    setActive(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });

    var hdr = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    const formData = new FormData();
    formData.append("splogo", aucsponsor);
    await DataService.addsponsor(formData, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);
        // //  console.log(response)
        if (response.success == true) {
          //  console.log('sponsor add response....!!')
          //  console.log(response.success)
          const db = getDatabase();
          //  console.log('sponsor add response ddd....!!')

          set(ref(db, "map/info/" + aid), {
            type: "1",
            upd: "6",
            id: aid,
            detail: {
              typ: 14,
              upd: 1,
              val: response.data.newentry,
            },
            tkn: updtoken,
          });
          // //  console.log("setted")
          //  console.log('sponsor add response eee....!!')

          setaucsponsorbox("");
          fileInputRefs.current.forEach((ref) => {
            if (ref.current) {
              ref.current.value = "";
            }
          });
          toast.success("Sponsor Added !!", {
            theme: "colored",
            position: "bottom-center",
          });
          //  console.log('sponsor add response 22222....!!')

          setaucdetail((prev) => ({
            ...prev,
            spn: [...prev.spn, response.data.newentry],
          }));

          setaucsponsor("");
        } else {
          //  console.log('sponsor add response 33333....!!')

          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }
        //  console.log('sponsor add response. 444...!!')

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  const chooseback = async () => {
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([
          { cid: cid, token: loginuser["token"] },
        ]),
      },
    };

    await DataService.bglist({}, hdr)
      .then((res) => {
        let response = res.data;
        if (response.success == true) {
          setbgdata(response.data);
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
    setisbgpop(!isbgpop);
  };
  const uploadfiles = async (typ) => {
    setActive(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });

    var hdr = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    const formData = new FormData();
    if (typ == "bg") {
      // if (aucbackbox == "") {

      //   formData.append("fl", aucback);
      // } else {
      //   alert('This background is already set !!')
      //   toast.dismiss(toastContainerId); // Dismiss the toast message here

      //   return 0
      // }
      formData.append("fl", aucback);

      const fileSizeKB = Math.round(aucback.size / 1024); // Convert bytes to kilobytes
      const fileSizeMB = (fileSizeKB / 1024).toFixed(2); // Convert kilobytes to megabytes
      if (fileSizeMB > 1.25) {
        alert("File size must be less than 1.25Mb");
        toast.dismiss(toastContainerId);
        return 0;
      }
    } else if (typ == "sstamp") {
      formData.append("fl", aucsoldstamp);
      const fileSizeKB = Math.round(aucsoldstamp.size / 1024); // Convert bytes to kilobytes
      const fileSizeMB = (fileSizeKB / 1024).toFixed(2); // Convert kilobytes to megabytes
      if (fileSizeMB > 1.25) {
        alert("File size must be less than 1.25Mb");
        toast.dismiss(toastContainerId);
        return 0;
      }
    } else if (typ == "usstamp") {
      formData.append("fl", aucunsoldstamp);
      const fileSizeKB = Math.round(aucunsoldstamp.size / 1024); // Convert bytes to kilobytes
      const fileSizeMB = (fileSizeKB / 1024).toFixed(2); // Convert kilobytes to megabytes
      if (fileSizeMB > 1.25) {
        alert("File size must be less than 1.25Mb");
        toast.dismiss(toastContainerId);
        return 0;
      }
    }

    formData.append("fltyp", typ);
    await DataService.addfiles(formData, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);
        if (response.success == true) {
          if (typ == "bg") {
            setaucdetail((detail) => ({
              ...detail,
              more: [{ ...detail.more[0], bg: response.data.newentry.logo }],
            }));
            setaucback("");
            const db = getDatabase();
            set(ref(db, "map/info/" + aid), {
              type: "1",
              upd: "6",
              id: aid,
              detail: {
                typ: 13,
                upd: 1,
                val: { img: response.data.newentry.logo },
              },
              tkn: updtoken,
            });
          } else if (typ == "sstamp") {
            setaucdetail((detail) => ({
              ...detail,
              more: [
                { ...detail.more[0], sstamp: response.data.newentry.logo },
              ],
            }));
            setaucsoldstamp("");
          } else if (typ == "usstamp") {
            setaucdetail((detail) => ({
              ...detail,
              more: [
                { ...detail.more[0], usstamp: response.data.newentry.logo },
              ],
            }));
            setaucunsoldstamp("");
          }
          // //  console.log("setted")
          fileInputRefs.current.forEach((ref) => {
            if (ref.current) {
              ref.current.value = "";
            }
          });
          toast.success("Added !!", {
            theme: "colored",
            position: "bottom-center",
          });

          // setaucdetail(prev => ({
          //   ...prev,
          //   spn: [...prev.spn, response.data.newentry]
          // }))
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  function setimagepopup(item, t) {
    setisimgpop(true);
    setimgpopdata(item);
    setimgpoptype(t);
  }
  const [mythemes] = useState([
    {
      no: 1,
      img: ovtheme1,
    },
    {
      no: 2,
      img: ovtheme2,
    },
    {
      no: 3,
      img: ovtheme3,
      img2: ovtheme4,
    },

    // Add more themes here as needed
  ]);
  const [currentImg, setCurrentImg] = useState(mythemes[2]?.img);

  const askdefaultset = (id) => {
    confirmAlert({
      message: "Are you want to download changes ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            downloadcustomchanges();
            defaultset(true);
          },
        },
        {
          label: "No",
          onClick: () => defaultset(true),
        },
      ],
    });
  };

  const handleDivClick2 = (themeNo) => {
    setTheme(themeNo);
    // Add any additional theme change logic here
  };

  const downloadcustomchanges = () => {
    // Create theme JSON object with current values
    const themeJSON = {
      primarycolor: primarycolor,
      primarycolor_gc1: primarycolor_gc1,
      primarycolor_gc2: primarycolor_gc2,
      sc1_sec1_gc1: sc1_sec1_gc1,
      sc1_sec1_gc2: sc1_sec1_gc2,
      sc1_sec1_gc3: sc1_sec1_gc3,
      sc1_sec2: sc1_sec2,
      sc1_plno_bg: sc1_plno_bg,
      sc1_pldetail_gc1: sc1_pldetail_gc1,
      sc1_pldetail_gc2: sc1_pldetail_gc2,
      sc1_pldetail_gc3: sc1_pldetail_gc3,
      sc1_crbid_bg1: sc1_crbid_bg1,
      sc1_crbid_bg2: sc1_crbid_bg2,
      sc1_crbid_bg3: sc1_crbid_bg3,
      sc1_plborder: sc1_plborder,
      sc1_plno_font: sc1_plno_font,
      sc1_plnm_font: sc1_plnm_font,
      sc1_bid_font: sc1_bid_font,
      sc2_primary_bg: sc2_primary_bg,
      sc2_plborder: sc2_plborder,
      sc2_crbid_bg: sc2_crbid_bg,
      sc2_tbHead_bg: sc2_tbHead_bg,
      sc2_tbOdd_bg: sc2_tbOdd_bg,
      sc2_tbEven_bg: sc2_tbEven_bg,
      sc2_plno_nm_font: sc2_plno_nm_font,
      sc2_crbid_font: sc2_crbid_font,
      sc2_tbHead_row_font: sc2_tbHead_row_font,

      secondarycolor: secondarycolor,

      primaryfontcolor: primaryfontcolor,
      secondaryfontcolor: secondaryfontcolor,
      theme: theme,
    };

    // Convert the object to a JSON string
    const dataStr = JSON.stringify(themeJSON, null, 2);

    // Create a Blob with the data
    const blob = new Blob([dataStr], { type: "application/json" });

    // Create a link element
    const link = document.createElement("a");

    // Create a download URL from the Blob
    const url = URL.createObjectURL(blob);

    // Set the download link attributes
    link.href = url;
    link.download = "overlay_theme.json"; // The name of the file to be saved

    // Programmatically click the link to trigger the download
    link.click();

    // Clean up by revoking the object URL after the download
    URL.revokeObjectURL(url);
  };

  // Add a function to handle importing saved theme
  const handleThemeImport = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const json = JSON.parse(e.target.result);
          // Set all theme parameters
          setprimarycolor(json.primarycolor || "#0a1c41");
          setprimarycolor_gc1(json.primarycolor_gc1 || "");
          setprimarycolor_gc2(json.primarycolor_gc2 || "");
          setsc1_sec1_gc1(json.sc1_sec1_gc1 || "#1b1842");
          setsc1_sec1_gc2(json.sc1_sec1_gc2 || "#242160");
          setsc1_sec1_gc3(json.sc1_sec1_gc3 || "#770c77");
          setsc1_sec2(json.sc1_sec2 || "#1b1842");
          setsc1_plno_bg(json.sc1_plno_bg || "#383892");
          setsc1_pldetail_gc1(json.sc1_pldetail_gc1 || "#1b1842");
          setsc1_pldetail_gc2(json.sc1_pldetail_gc2 || "#0c147e");
          setsc1_pldetail_gc3(json.sc1_pldetail_gc3 || "#1b1842");
          setsc1_crbid_bg1(json.sc1_crbid_bg1 || "#a3c9d6");
          setsc1_crbid_bg2(json.sc1_crbid_bg2 || "#4389a5");
          setsc1_crbid_bg3(json.sc1_crbid_bg3 || "#4eafd6");
          setsc1_plborder(json.sc1_plborder || "#d3c366");
          setsc1_plno_font(json.sc1_plno_font || "#eebbc4");
          setsc1_plnm_font(json.sc1_plnm_font || "#6ad6d1");
          setsc1_bid_font(json.sc1_bid_font || "#0b0b36");
          setsc2_primary_bg(json.sc2_primary_bg || "#4e1a80");
          setsc2_plborder(json.sc2_plborder || "#0000ff");
          setsc2_crbid_bg(json.sc2_crbid_bg || "#dbd6e0");
          setsc2_tbHead_bg(json.sc2_tbHead_bg || "#b8f1f1");
          setsc2_tbOdd_bg(json.sc2_tbOdd_bg || "#1b1ba0");
          setsc2_tbEven_bg(json.sc2_tbEven_bg || "#ffffff");
          setsc2_plno_nm_font(json.sc2_plno_nm_font || "#ffff00");
          setsc2_crbid_font(json.sc2_crbid_font || "#4e1a80");
          setsc2_tbHead_row_font(json.sc2_tbHead_row_font || "#262696");

          setsecondarycolor(json.secondarycolor || "#00ffdf");
          setprimaryfontcolor(json.primaryfontcolor || "#002236");
          setsecondaryfontcolor(json.secondaryfontcolor || "#ffffff");
          settertiarycolor(json.tertiarycolor || "#082842");
          settertiaryfontcolor(json.tertiaryfontcolor || "#ffffff");
          setTheme(json.theme || 1);

          toast.success("Theme imported successfully!", { theme: "colored" });
        } catch (error) {
          console.error("Error parsing JSON:", error);
          toast.error("Invalid theme file", { theme: "colored" });
        }
      };
      reader.readAsText(file);
      // Reset the file input
      event.target.value = "";
    }
  };

  const handleClick = (screen) => {
    setActiveScreen(screen);
    setisClicked(true);
  };

  return (
    <div>
      <Navigationtitle data={match} />
      
      <div className="custom_auction_theme custom_overlay">
        <div className="custom_options">
          <div
            className={`custom_options_child ${
              customtype == "theme" && "active_blue"
            }`}
            onClick={() => setcustomtype("theme")}
          >
            <div>
              <BsLayoutWtf />
            </div>
            <div>
              <label htmlFor="">Theme</label>
            </div>
          </div>
          <div
            className={`custom_options_child ${
              customtype == "data" && "active_blue"
            }`}
            onClick={() => setcustomtype("data")}
          >
            <div>
              <TbListDetails />
            </div>
            <div>
              <label htmlFor="">Content</label>
            </div>
          </div>
          <div
            className={`custom_options_child`}
            onClick={() => askdefaultset()}
          >
            <div>
              <MdOutlineSettingsBackupRestore />
            </div>
            <div>
              <label htmlFor="">Default</label>
            </div>
          </div>
          <div className="custom_options_child" onClick={handleImportClick}>
            <div>
              <CiImport />
            </div>
            <div>
              <label htmlFor="">Import</label>
            </div>

            <input
              type="file"
              id="fileInputt"
              style={{ display: "none" }}
              accept=".json"
              onChange={handleThemeImport}
            />
          </div>
        </div>
        <div className="Custom_available_options">
          {customtype == "theme" && (
            <>
              <div className="backgrounds_container">
                <div className="custom_head">Choose Theme</div>
                <div>
                  {mythemes.map((ele, index) => {
                    return (
                      <div
                        key={index}
                        className={`custom_option_image ${
                          theme === ele.no ? "selected" : ""
                        }`}
                        onClick={() => handleDivClick2(ele.no)}
                        style={
                          theme === ele.no
                            ? {
                                border: `2px solid ${secondarycolor}`,
                                boxShadow: `0 0 10px ${secondarycolor}`,
                              }
                            : {}
                        }
                      >
                        <img src={ele.no === 3 ? currentImg : ele.img} alt="" />
                      </div>
                    );
                  })}
                </div>
              </div>
            </>
          )}
          {customtype == "data" && (
            <>
              {theme == 1 && (
                <>
                  <div className="custom_color_options">
                    <div className="col_label">
                      <label htmlFor="">Choose background color</label>
                                </div>
                            </div>
                  <div className="custom_color_options">
                    <div
                      className="col_label"
                      onMouseEnter={() => setHoveredSection("th1_primecolor")}
                      onMouseLeave={() => setHoveredSection(null)}
                      style={{ cursor: "pointer" }}
                    >
                      {hoveredSection === "th1_primecolor" ? (
                        <MdOutlineRefresh
                          size={18}
                          className="refresh_icon"
                          onClick={() => handleResetColors("th1_primecolor")}
                        />
                      ) : (
                        <IoColorPaletteOutline className="col_icon" />
                      )}
                      <label htmlFor="">Primary color</label>
                    </div>
                    <input
                      type="color"
                      className="color_inp rounded-color-input"
                      value={primarycolor}
                      onChange={(e) => setprimarycolor(e.target.value)}
                    />
                  </div>
                </>
              )}
              {theme == 2 && (
                <>
                  <div className="custom_color_options">
                    <div className="col_label">
                      <label htmlFor="">Choose background color</label>
                    </div>
                  </div>
                  <div className="custom_color_options">
                    <div className="col_label">
                      <IoColorPaletteOutline className="col_icon" />
                      <label htmlFor="">Primary color</label>
                    </div>
                    <input
                      type="color"
                      className="color_inp rounded-color-input"
                      value={primarycolor_gc1}
                      onChange={(e) => setprimarycolor_gc1(e.target.value)}
                    />
                    <input
                      type="color"
                      className="color_inp rounded-color-input"
                      value={primarycolor_gc2}
                      onChange={(e) => setprimarycolor_gc2(e.target.value)}
                    />
                  </div>
                </>
              )}

              {theme == 3 ? (
                activeScreen === "screen1" ? (
                  <>
                    <div className="custom_color_options screen-heading">
                      <div className="col_label screen-div">
                        <label htmlFor="" className="screen-label">
                          Screen1 color
                        </label>
                      </div>
                    </div>

                    <div
                      className="custom_drawer"
                      onClick={() => toggleDrawer("colors")}
                    >
                      <div className="main_col_label">
                        <IoColorPaletteOutline className="main_col_icon" />
                        <label htmlFor=""> Colors</label>
                      </div>
                      {activeDrawer === "colors" ? (
                        <FaChevronDown />
                      ) : (
                        <FaChevronRight />
                      )}
                    </div>

                    {activeDrawer === "colors" && (
                      <div
                        className={`custom_color_div  ${
                          activeDrawer === "colors" ? "open" : ""
                        }`}
                      >
                        <div className="custom_color_options theme3_colors">
                          <div className="input_section">
                            <div
                              className="col_label"
                              onMouseEnter={() => setHoveredSection("sc1_sec1")}
                              onMouseLeave={() => setHoveredSection(null)}
                              style={{ cursor: "pointer" }}
                            >
                              {hoveredSection === "sc1_sec1" ? (
                                <MdOutlineRefresh
                                  size={18}
                                  className="refresh_icon"
                                  onClick={() => handleResetColors("sc1_sec1")}
                                />
                              ) : (
                                <IoColorPaletteOutline className="col_icon" />
                              )}
                              <label htmlFor="" title={isAdmin ? "sc1_sec1_gc1\nsc1_sec1_gc2\nsc1_sec1_gc3" : ""}>Section1</label>
                            </div>
                            <div className="color-input">
                              <input
                                type="color"
                                className="color_inp rounded-color-input"
                                value={sc1_sec1_gc1}
                                onChange={(e) =>
                                  setsc1_sec1_gc1(e.target.value)
                                }
                              />

                              <input
                                type="color"
                                className="color_inp rounded-color-input"
                                value={sc1_sec1_gc2}
                                onChange={(e) =>
                                  setsc1_sec1_gc2(e.target.value)
                                }
                              />
                              <input
                                type="color"
                                className="color_inp rounded-color-input"
                                value={sc1_sec1_gc3}
                                onChange={(e) =>
                                  setsc1_sec1_gc3(e.target.value)
                                }
                              />
                            </div>
                          </div>
                          
                        </div>
                        <div className="custom_color_options theme3_colors">
                          <div className="input_section one-input-sec">
                            <div
                              className="col_label"
                              onMouseEnter={() => setHoveredSection("sc1_sec2")}
                              onMouseLeave={() => setHoveredSection(null)}
                              style={{ cursor: "pointer" }}
                            >
                              {hoveredSection === "sc1_sec2" ? (
                                <MdOutlineRefresh
                                  size={18}
                                  className="refresh_icon"
                                  onClick={() => handleResetColors("sc1_sec2")}
                                />
                              ) : (
                                <IoColorPaletteOutline className="col_icon" />
                              )}
                              <label htmlFor="" title={isAdmin ? "sc1_sec2" : ""}>Section2</label>
                            </div>
                            <input
                              type="color"
                              className="color_inp rounded-color-input"
                              value={sc1_sec2}
                              onChange={(e) => setsc1_sec2(e.target.value)}
                            />
                          </div>
                          
                        </div>
                        <div className="custom_color_options theme3_colors">
                          <div className="input_section one-input-sec">
                            <div
                              className="col_label"
                              onMouseEnter={() => setHoveredSection("sc1_plno")}
                              onMouseLeave={() => setHoveredSection(null)}
                              style={{ cursor: "pointer" }}
                            >
                              {hoveredSection === "sc1_plno" ? (
                                <MdOutlineRefresh
                                  size={17}
                                  className="refresh_icon"
                                  onClick={() => handleResetColors("sc1_plno")}
                                />
                              ) : (
                                <IoColorPaletteOutline className="col_icon" />
                              )}
                              <label htmlFor="" title={isAdmin ? "sc1_plno_bg" : ""}>Pl No </label>
                            </div>
                            <input
                              type="color"
                              className="color_inp rounded-color-input"
                              value={sc1_plno_bg}
                              onChange={(e) => setsc1_plno_bg(e.target.value)}
                            />
                          </div>
                          
                        </div>
                        <div className="custom_color_options theme3_colors">
                          <div className="input_section one-input-sec">
                            <div
                              className="col_label"
                              onMouseEnter={() =>
                                setHoveredSection("sc1_pldetail")
                              }
                              onMouseLeave={() => setHoveredSection(null)}
                              style={{ cursor: "pointer" }}
                            >
                              {hoveredSection === "sc1_pldetail" ? (
                                <MdOutlineRefresh
                                  size={18}
                                  className="refresh_icon"
                                  onClick={() =>
                                    handleResetColors("sc1_pldetail")
                                  }
                                />
                              ) : (
                                <IoColorPaletteOutline className="col_icon" />
                              )}
                              <label htmlFor="" title={isAdmin ? " sc1_pldetail_gc1\nsc1_pldetail_gc2\nsc1_pldetail_gc3" : ""}>Pl Detail</label>
                            </div>
                            <div className="color-input">
                              <input
                                type="color"
                                className="color_inp rounded-color-input"
                                value={sc1_pldetail_gc1}
                                onChange={(e) =>
                                  setsc1_pldetail_gc1(e.target.value)
                                }
                              />
                              <input
                                type="color"
                                className="color_inp rounded-color-input"
                                value={sc1_pldetail_gc2}
                                onChange={(e) =>
                                  setsc1_pldetail_gc2(e.target.value)
                                }
                              />
                              <input
                                type="color"
                                className="color_inp rounded-color-input"
                                value={sc1_pldetail_gc3}
                                onChange={(e) =>
                                  setsc1_pldetail_gc3(e.target.value)
                                }
                              />
                            </div>
                          </div>
                         
                        </div>
                        <div className="custom_color_options theme3_colors">
                          <div className="input_section one-input-sec">
                            <div
                              className="col_label"
                              onMouseEnter={() =>
                                setHoveredSection("sc1_crbid")
                              }
                              onMouseLeave={() => setHoveredSection(null)}
                              style={{ cursor: "pointer" }}
                            >
                              {hoveredSection === "sc1_crbid" ? (
                                <MdOutlineRefresh
                                  size={18}
                                  className="refresh_icon"
                                  onClick={() => handleResetColors("sc1_crbid")}
                                />
                              ) : (
                                <IoColorPaletteOutline className="col_icon" />
                              )}
                              <label htmlFor="" title={isAdmin ? "sc1_crbid_bg1\nsc1_crbid_bg2\nsc1_crbid_bg3" : ""}>Cr Bid </label>
                            </div>
                            <div className="color-input">
                              <input
                                type="color"
                                className="color_inp rounded-color-input"
                                value={sc1_crbid_bg1}
                                onChange={(e) =>
                                  setsc1_crbid_bg1(e.target.value)
                                }
                              />
                              <input
                                type="color"
                                className="color_inp rounded-color-input"
                                value={sc1_crbid_bg2}
                                onChange={(e) =>
                                  setsc1_crbid_bg2(e.target.value)
                                }
                              />
                              <input
                                type="color"
                                className="color_inp rounded-color-input"
                                value={sc1_crbid_bg3}
                                onChange={(e) =>
                                  setsc1_crbid_bg3(e.target.value)
                                }
                              />
                            </div>
                          </div>
                          
                        </div>
                        <div className="custom_color_options theme3_colors">
                          <div className="input_section one-input-sec">
                            <div
                              className="col_label"
                              onMouseEnter={() =>
                                setHoveredSection("sc1_plborder")
                              }
                              onMouseLeave={() => setHoveredSection(null)}
                              style={{ cursor: "pointer" }}
                            >
                              {hoveredSection === "sc1_plborder" ? (
                                <MdOutlineRefresh
                                  size={18}
                                  className="refresh_icon"
                                  onClick={() =>
                                    handleResetColors("sc1_plborder")
                                  }
                                />
                              ) : (
                                <IoColorPaletteOutline className="col_icon" />
                              )}
                              <label htmlFor="" title={isAdmin ? "sc1_plborder" : ""} >Pl Border</label>
                            </div>
                            <input
                              type="color"
                              className="color_inp rounded-color-input"
                              value={sc1_plborder}
                              onChange={(e) => setsc1_plborder(e.target.value)}
                            />
                          </div>
                          
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    <div className="custom_color_options screen-heading">
                      <div className="col_label screen-div">
                        <label htmlFor="" className="screen-label">
                          Screen2 color
                        </label>
                      </div>
                    </div>
                    <div
                      className="custom_drawer"
                      onClick={() => toggleDrawer("colors")}
                    >
                      <div className="main_col_label">
                        <IoColorPaletteOutline className="main_col_icon" />
                        <label htmlFor=""> Colors</label>
                      </div>
                      {activeDrawer === "colors" ? (
                        <FaChevronDown />
                      ) : (
                        <FaChevronRight />
                      )}
                    </div>

                    {activeDrawer === "colors" && (
                      <div
                        className={`custom_color_div  ${
                          activeDrawer === "colors" ? "open" : ""
                        }`}
                      >
                        <div className="custom_color_options theme3_colors">
                          <div className="input_section one-input-sec">
                            <div
                              className="col_label"
                              onMouseEnter={() =>
                                setHoveredSection("sc2_primary")
                              }
                              onMouseLeave={() => setHoveredSection(null)}
                              style={{ cursor: "pointer" }}
                            >
                              {hoveredSection === "sc2_primary" ? (
                                <MdOutlineRefresh
                                  size={18}
                                  className="refresh_icon"
                                  onClick={() =>
                                    handleResetColors("sc2_primary")
                                  }
                                />
                              ) : (
                                <IoColorPaletteOutline className="col_icon" />
                              )}
                              <label htmlFor="" title={isAdmin ? "sc2_primary_bg" : ""}>Primary</label>
                            </div>
                            <input
                              type="color"
                              className="color_inp rounded-color-input"
                              value={sc2_primary_bg}
                              onChange={(e) =>
                                setsc2_primary_bg(e.target.value)
                              }
                            />
                          </div>
                          
                        </div>
                        <div className="custom_color_options theme3_colors">
                          <div className="input_section one-input-sec">
                            <div
                              className="col_label"
                              onMouseEnter={() =>
                                setHoveredSection("sc2_plborder")
                              }
                              onMouseLeave={() => setHoveredSection(null)}
                              style={{ cursor: "pointer" }}
                            >
                              {hoveredSection === "sc2_plborder" ? (
                                <MdOutlineRefresh
                                  size={18}
                                  className="refresh_icon"
                                  onClick={() =>
                                    handleResetColors("sc2_plborder")
                                  }
                                />
                              ) : (
                                <IoColorPaletteOutline className="col_icon" />
                              )}
                              <label htmlFor="" title={isAdmin ? "sc2_plborder" : ""}>Pl Border</label>
                            </div>
                            <input
                              type="color"
                              className="color_inp rounded-color-input"
                              value={sc2_plborder}
                              onChange={(e) => setsc2_plborder(e.target.value)}
                            />
                          </div>
                         
                        </div>
                        <div className="custom_color_options theme3_colors">
                          <div className="input_section one-input-sec">
                            <div
                              className="col_label"
                              onMouseEnter={() =>
                                setHoveredSection("sc2_crbid")
                              }
                              onMouseLeave={() => setHoveredSection(null)}
                              style={{ cursor: "pointer" }}
                            >
                              {hoveredSection === "sc2_crbid" ? (
                                <MdOutlineRefresh
                                  size={17}
                                  className="refresh_icon"
                                  onClick={() => handleResetColors("sc2_crbid")}
                                />
                              ) : (
                                <IoColorPaletteOutline className="col_icon" />
                              )}
                              <label htmlFor="" title={isAdmin ? "sc2_crbid_bg" : ""}>Cr Bid </label>
                            </div>
                            <input
                              type="color"
                              className="color_inp rounded-color-input"
                              value={sc2_crbid_bg}
                              onChange={(e) => setsc2_crbid_bg(e.target.value)}
                            />
                          </div>
                          
                        </div>
                        <div className="custom_color_options theme3_colors">
                          <div className="input_section one-input-sec">
                            <div
                              className="col_label"
                              onMouseEnter={() =>
                                setHoveredSection("sc2_tbhead")
                              }
                              onMouseLeave={() => setHoveredSection(null)}
                              style={{ cursor: "pointer" }}
                            >
                              {hoveredSection === "sc2_tbhead" ? (
                                <MdOutlineRefresh
                                  size={17}
                                  className="refresh_icon"
                                  onClick={() =>
                                    handleResetColors("sc2_tbhead")
                                  }
                                />
                              ) : (
                                <IoColorPaletteOutline className="col_icon" />
                              )}
                              <label htmlFor="" title={isAdmin ? "sc2_tbHead_bg" : ""}>TB Header</label>
                            </div>
                            <input
                              type="color"
                              className="color_inp rounded-color-input"
                              value={sc2_tbHead_bg}
                              onChange={(e) => setsc2_tbHead_bg(e.target.value)}
                            />
                          </div>
                          
                        </div>
                        <div className="custom_color_options theme3_colors">
                          <div className="input_section one-input-sec">
                            <div
                              className="col_label"
                              onMouseEnter={() =>
                                setHoveredSection("sc2_tboddrow")
                              }
                              onMouseLeave={() => setHoveredSection(null)}
                              style={{ cursor: "pointer" }}
                            >
                              {hoveredSection === "sc2_tboddrow" ? (
                                <MdOutlineRefresh
                                  size={18}
                                  className="refresh_icon"
                                  onClick={() =>
                                    handleResetColors("sc2_tboddrow")
                                  }
                                />
                              ) : (
                                <IoColorPaletteOutline className="col_icon" />
                              )}
                              <label htmlFor="" title={isAdmin ? "sc2_tbOdd_bg" : ""}>TB OddRow</label>
                            </div>
                            <input
                              type="color"
                              className="color_inp rounded-color-input"
                              value={sc2_tbOdd_bg}
                              onChange={(e) => setsc2_tbOdd_bg(e.target.value)}
                            />
                          </div>
                         
                        </div>
                        <div className="custom_color_options theme3_colors">
                          <div className="input_section one-input-sec">
                            <div
                              className="col_label"
                              onMouseEnter={() =>
                                setHoveredSection("sc2_tbevenrow")
                              }
                              onMouseLeave={() => setHoveredSection(null)}
                              style={{ cursor: "pointer" }}
                            >
                              {hoveredSection === "sc2_tbevenrow" ? (
                                <MdOutlineRefresh
                                  size={17}
                                  className="refresh_icon"
                                  onClick={() =>
                                    handleResetColors("sc2_tbevenrow")
                                  }
                                />
                              ) : (
                                <IoColorPaletteOutline className="col_icon" />
                              )}
                              <label htmlFor="" title={isAdmin ? "sc2_tbEven_bg" : ""}>TB EvenRow</label>
                            </div>
                            <input
                              type="color"
                              className="color_inp rounded-color-input"
                              value={sc2_tbEven_bg}
                              onChange={(e) => setsc2_tbEven_bg(e.target.value)}
                            />
                          </div>
                          
                        </div>
                      </div>
                    )}
                  </>
                )
              ) : null}

              {(theme == 1 || theme == 2) && (
                <div className="custom_color_options">
                  <div
                    className="col_label"
                    onMouseEnter={() => setHoveredSection("sec_color")}
                    onMouseLeave={() => setHoveredSection(null)}
                    style={{ cursor: "pointer" }}
                  >
                    {hoveredSection === "sec_color" ? (
                      <MdOutlineRefresh
                        size={18}
                        className="refresh_icon"
                        onClick={() => handleResetColors("sec_color")}
                      />
                    ) : (
                      <IoColorPaletteOutline className="col_icon" />
                    )}
                    <label htmlFor="">Secondary color</label>
                  </div>
                  <input
                    type="color"
                    className="color_inp rounded-color-input"
                    value={secondarycolor}
                    onChange={(e) => setsecondarycolor(e.target.value)}
                  />
                            </div>
              )}
              {theme == 1 && (
                <div className="custom_color_options">
                  <div
                    className="col_label"
                    onMouseEnter={() => setHoveredSection("tertiary_color")}
                    onMouseLeave={() => setHoveredSection(null)}
                    style={{ cursor: "pointer" }}
                  >
                    {hoveredSection === "tertiary_color" ? (
                      <MdOutlineRefresh
                        size={18}
                        className="refresh_icon"
                        onClick={() => handleResetColors("tertiary_color")}
                      />
                    ) : (
                      <IoColorPaletteOutline className="col_icon" />
                    )}
                    <label htmlFor="">Tertiary color</label>
                  </div>
                  <input
                    type="color"
                    className="color_inp rounded-color-input"
                    value={tertiarycolor}
                    onChange={(e) => settertiarycolor(e.target.value)}
                  />
                </div>
              )}
              {(theme == 1 || theme == 2) && (
                <>
                  <div className="custom_color_options">
                    <div className="col_label">
                                    <label htmlFor="">Choose Font color</label>
                                </div>
                            </div>
                  <div className="custom_color_options">
                    <div
                      className="col_label"
                      onMouseEnter={() => setHoveredSection("primefont_color")}
                      onMouseLeave={() => setHoveredSection(null)}
                      style={{ cursor: "pointer" }}
                    >
                      {hoveredSection === "primefont_color" ? (
                        <MdOutlineRefresh
                          size={18}
                          className="refresh_icon"
                          onClick={() => handleResetColors("primefont_color")}
                        />
                      ) : (
                        <IoColorPaletteOutline className="col_icon" />
                      )}
                      <label htmlFor="">Primary color</label>
                    </div>
                    <input
                      type="color"
                      className="color_inp rounded-color-input"
                      value={primaryfontcolor}
                      onChange={(e) => setprimaryfontcolor(e.target.value)}
                    />
                            </div>
                </>
              )}
              {theme == 1 && (
                <>
                  <div className="custom_color_options">
                    <div
                      className="col_label"
                      onMouseEnter={() => setHoveredSection("secfont_color")}
                      onMouseLeave={() => setHoveredSection(null)}
                      style={{ cursor: "pointer" }}
                    >
                      {hoveredSection === "secfont_color" ? (
                        <MdOutlineRefresh
                          size={18}
                          className="refresh_icon"
                          onClick={() => handleResetColors("secfont_color")}
                        />
                      ) : (
                        <IoColorPaletteOutline className="col_icon" />
                      )}
                      <label htmlFor="">Secondary color</label>
                    </div>
                    <input
                      type="color"
                      className="color_inp rounded-color-input"
                      value={secondaryfontcolor}
                      onChange={(e) => setsecondaryfontcolor(e.target.value)}
                    />
                  </div>
                  <div className="custom_color_options">
                    <div
                      className="col_label"
                      onMouseEnter={() =>
                        setHoveredSection("tertiaryfont_color")
                      }
                      onMouseLeave={() => setHoveredSection(null)}
                      style={{ cursor: "pointer" }}
                    >
                      {hoveredSection === "tertiaryfont_color" ? (
                        <MdOutlineRefresh
                          size={17}
                          className="refresh_icon"
                          onClick={() =>
                            handleResetColors("tertiaryfont_color")
                          }
                        />
                      ) : (
                        <IoColorPaletteOutline className="col_icon" />
                      )}
                      <label htmlFor="">Tertiary color</label>
                    </div>
                    <input
                      type="color"
                      className="color_inp rounded-color-input"
                      value={tertiaryfontcolor}
                      onChange={(e) => settertiaryfontcolor(e.target.value)}
                    />
                  </div>
                </>
              )}

              {theme == 3 ? (
                activeScreen === "screen1" ? (
                  <>
                    <div
                      className="custom_drawer"
                      onClick={() => toggleDrawer("fonts")}
                    >
                      <div className="main_col_label">
                        <IoColorPaletteOutline className="main_col_icon" />
                        <label htmlFor=""> Fonts</label>
                      </div>
                      {activeDrawer === "fonts" ? (
                        <FaChevronDown />
                      ) : (
                        <FaChevronRight />
                      )}
                    </div>

                    {activeDrawer === "fonts" && (
                      <div
                        className={`custom_font_div ${
                          activeDrawer === "fonts" ? "open" : ""
                        }`}
                      >
                        <div className="custom_color_options theme3_colors">
                          <div className="input_section one-input-sec">
                            <div
                              className="col_label"
                              onMouseEnter={() =>
                                setHoveredSection("primefont_color")
                              }
                              onMouseLeave={() => setHoveredSection(null)}
                              style={{ cursor: "pointer" }}
                            >
                              {hoveredSection === "primefont_color" ? (
                                <MdOutlineRefresh
                                  size={18}
                                  className="refresh_icon"
                                  onClick={() =>
                                    handleResetColors("primefont_color")
                                  }
                                />
                              ) : (
                                <IoColorPaletteOutline className="col_icon" />
                              )}
                              <label htmlFor="" title={isAdmin ? "primaryfontcolor" : ""}>Primary color</label>
                            </div>
                            <input
                              type="color"
                              className="color_inp rounded-color-input"
                              value={primaryfontcolor}
                              onChange={(e) =>
                                setprimaryfontcolor(e.target.value)
                              }
                            />
                          </div>
                          
                        </div>
                        <div className="custom_color_options theme3_colors">
                          <div className="input_section one-input-sec">
                            <div
                              className="col_label"
                              onMouseEnter={() =>
                                setHoveredSection("sc1_plnofont")
                              }
                              onMouseLeave={() => setHoveredSection(null)}
                              style={{ cursor: "pointer" }}
                            >
                              {hoveredSection === "sc1_plnofont" ? (
                                <MdOutlineRefresh
                                  size={18}
                                  className="refresh_icon"
                                  onClick={() =>
                                    handleResetColors("sc1_plnofont")
                                  }
                                />
                              ) : (
                                <IoColorPaletteOutline className="col_icon" />
                              )}
                              <label htmlFor="" title={isAdmin ? "sc1_plno_font" : ""}>Pl No.</label>
                            </div>
                            <input
                              type="color"
                              className="color_inp rounded-color-input"
                              value={sc1_plno_font}
                              onChange={(e) => setsc1_plno_font(e.target.value)}
                            />
                          </div>
                          
                        </div>
                        <div className="custom_color_options theme3_colors">
                          <div className="input_section one-input-sec">
                            <div
                              className="col_label"
                              onMouseEnter={() =>
                                setHoveredSection("sc1_plnmfont")
                              }
                              onMouseLeave={() => setHoveredSection(null)}
                              style={{ cursor: "pointer" }}
                            >
                              {hoveredSection === "sc1_plnmfont" ? (
                                <MdOutlineRefresh
                                  size={18}
                                  className="refresh_icon"
                                  onClick={() =>
                                    handleResetColors("sc1_plnmfont")
                                  }
                                />
                              ) : (
                                <IoColorPaletteOutline className="col_icon" />
                              )}
                              <label htmlFor="" title={isAdmin ? "sc1_plnm_font" : ""}>Pl name </label>
                            </div>
                            <input
                              type="color"
                              className="color_inp rounded-color-input"
                              value={sc1_plnm_font}
                              onChange={(e) => setsc1_plnm_font(e.target.value)}
                            />
                          </div>
                          
                        </div>
                        <div className="custom_color_options theme3_colors">
                          <div className="input_section one-input-sec">
                            <div
                              className="col_label"
                              onMouseEnter={() =>
                                setHoveredSection("sc1_bidfont")
                              }
                              onMouseLeave={() => setHoveredSection(null)}
                              style={{ cursor: "pointer" }}
                            >
                              {hoveredSection === "sc1_bidfont" ? (
                                <MdOutlineRefresh
                                  size={18}
                                  className="refresh_icon"
                                  onClick={() =>
                                    handleResetColors("sc1_bidfont")
                                  }
                                />
                              ) : (
                                <IoColorPaletteOutline className="col_icon" />
                              )}
                              <label htmlFor="" title={isAdmin ? "sc1_bid_font" : ""}> Bid</label>
                            </div>
                            <input
                              type="color"
                              className="color_inp rounded-color-input"
                              value={sc1_bid_font}
                              onChange={(e) => setsc1_bid_font(e.target.value)}
                            />
                          </div>
                          
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    <div
                      className="custom_drawer"
                      onClick={() => toggleDrawer("fonts")}
                    >
                      <div className="main_col_label">
                        <IoColorPaletteOutline className="main_col_icon" />
                        <label htmlFor=""> Fonts</label>
                      </div>
                      {activeDrawer === "fonts" ? (
                        <FaChevronDown />
                      ) : (
                        <FaChevronRight />
                      )}
                    </div>

                    {activeDrawer === "fonts" && (
                      <div
                        className={`custom_font_div ${
                          activeDrawer === "fonts" ? "open" : ""
                        }`}
                      >
                        <div className="custom_color_options theme3_colors">
                          <div className="input_section one-input-sec">
                            <div
                              className="col_label"
                              onMouseEnter={() =>
                                setHoveredSection("primefont_color")
                              }
                              onMouseLeave={() => setHoveredSection(null)}
                              style={{ cursor: "pointer" }}
                            >
                              {hoveredSection === "primefont_color" ? (
                                <MdOutlineRefresh
                                  size={18}
                                  className="refresh_icon"
                                  onClick={() =>
                                    handleResetColors("primefont_color")
                                  }
                                />
                              ) : (
                                <IoColorPaletteOutline className="col_icon" />
                              )}
                              <label htmlFor="" title={isAdmin ? "primaryfontcolor" : ""}>Primary color</label>
                            </div>
                            <input
                              type="color"
                              className="color_inp rounded-color-input"
                              value={primaryfontcolor}
                              onChange={(e) =>
                                setprimaryfontcolor(e.target.value)
                              }
                            />
                          </div>
                         
                        </div>
                        <div className="custom_color_options theme3_colors">
                          <div className="input_section one-input-sec">
                            <div
                              className="col_label"
                              onMouseEnter={() =>
                                setHoveredSection("sc2_plno_nmfont")
                              }
                              onMouseLeave={() => setHoveredSection(null)}
                              style={{ cursor: "pointer" }}
                            >
                              {hoveredSection === "sc2_plno_nmfont" ? (
                                <MdOutlineRefresh
                                  size={18}
                                  className="refresh_icon"
                                  onClick={() =>
                                    handleResetColors("sc2_plno_nmfont")
                                  }
                                />
                              ) : (
                                <IoColorPaletteOutline className="col_icon" />
                              )}
                              <label htmlFor="" title={isAdmin ? "sc2_plno_nm_font" : ""}>Pl No./Name</label>
                            </div>
                            <input
                              type="color"
                              className="color_inp rounded-color-input"
                              value={sc2_plno_nm_font}
                              onChange={(e) =>
                                setsc2_plno_nm_font(e.target.value)
                              }
                            />
                          </div>
                          
                        </div>

                        <div className="custom_color_options theme3_colors">
                          <div className="input_section one-input-sec">
                            <div
                              className="col_label"
                              onMouseEnter={() =>
                                setHoveredSection("sc2_crbidfont")
                              }
                              onMouseLeave={() => setHoveredSection(null)}
                              style={{ cursor: "pointer" }}
                            >
                              {hoveredSection === "sc2_crbidfont" ? (
                                <MdOutlineRefresh
                                  size={18}
                                  className="refresh_icon"
                                  onClick={() =>
                                    handleResetColors("sc2_crbidfont")
                                  }
                                />
                              ) : (
                                <IoColorPaletteOutline className="col_icon" />
                              )}
                              <label htmlFor="" title={isAdmin ? "sc2_crbid_font" : ""}> Bid</label>
                            </div>
                            <input
                              type="color"
                              className="color_inp rounded-color-input"
                              value={sc2_crbid_font}
                              onChange={(e) =>
                                setsc2_crbid_font(e.target.value)
                              }
                            />
                          </div>
                          
                        </div>

                        <div className="custom_color_options theme3_colors">
                          <div className="input_section one-input-sec">
                            <div
                              className="col_label"
                              onMouseEnter={() =>
                                setHoveredSection("sc2_tbhead_rowfont")
                              }
                              onMouseLeave={() => setHoveredSection(null)}
                              style={{ cursor: "pointer" }}
                            >
                              {hoveredSection === "sc2_tbhead_rowfont" ? (
                                <MdOutlineRefresh
                                  size={18}
                                  className="refresh_icon"
                                  onClick={() =>
                                    handleResetColors("sc2_tbhead_rowfont")
                                  }
                                />
                              ) : (
                                <IoColorPaletteOutline className="col_icon" />
                              )}
                              <label htmlFor="" title={isAdmin ? "sc2_tbHead_row_font" : ""}>TB Row</label>
                            </div>
                            <input
                              type="color"
                              className="color_inp rounded-color-input"
                              value={sc2_tbHead_row_font}
                              onChange={(e) =>
                                setsc2_tbHead_row_font(e.target.value)
                              }
                            />
                          </div>
                         
                        </div>
                      </div>
                    )}
                  </>
                )
              ) : null}
            </>
          )}
        </div>
        <div className="custom_preview">
          {theme == 1 && (
            <>
              <div class="box1 fb_profile">
                <div
                  class="tp"
                  style={{ "--secondary-color": secondarycolor }}
                ></div>
                <div
                  class="btm"
                  style={{ "--secondary-color": secondarycolor }}
                ></div>
                <div
                  id="playername"
                  class="fnt1 fs1 l2"
                  style={{
                    background: secondarycolor,
                    border: `1px solid ${secondarycolor}`,
                    boxShadow: `inset 0 0 5px ${secondarycolor}`,
                    color: primaryfontcolor,
                  }}
                >
                  Sonu bajaj
                </div>
                <div
                  id="tempdetail"
                  style={{ background: primarycolor, color: secondarycolor }}
                  class="tempdetail"
                >
                  <div class="agediv">
                    <h4 style={{ color: secondaryfontcolor }}>
                      All-rounder Batsman
                    </h4>
                  </div>
                  <div class="agediv">
                    <h4 style={{ color: secondaryfontcolor }}>
                      Right Armed Player
                    </h4>
                  </div>
                </div>
                <div
                  id="playerbase"
                  style={{
                    color: tertiaryfontcolor,
                    background: tertiarycolor,
                  }}
                >
                  <div class="lbl" style={{ color: tertiaryfontcolor }}>
                    BASE VALUE
                  </div>
                  <div class="val">
                    {" "}
                    180<span class="pointtyp"> lakh</span>
                  </div>
                  <div style={{ clear: "both" }}></div>
                </div>
                <div id="playerinfo"></div>
                {/* <div id="soldto" ><div class="lbl">SOLD TO</div><div class="val"></div><div style={{clear:'both'}}></div></div>
                        <div id="unsolddiv" >UNSOLD</div> */}
              </div>
              <div
                class="imgbox plr fb_profile jpg"
                style={{
                  background: `url(${hexagon}) no-repeat`,
                  backgroundSize: "100%",
                  backgroundPosition: "bottom",
                }}
              >
                {/* <div id="pic" style="display:none">
                            <img src=""/>
                        </div> */}
                <div id="bidtm">
                  <img src="" />
                </div>
              </div>
              <div class="box2 fb_profile">
                <div class="tp"></div>
                <div class="btm"></div>
                <div
                  class="bidpoint"
                  style={{
                    background: secondarycolor,
                    color: primaryfontcolor,
                    border: `1px solid ${secondarycolor}`,
                    boxShadow: `inset 0 0 5px ${secondarycolor}`,
                  }}
                >
                  <div class="lbl">CURRENT BID</div>
                  <div class="val fs0">
                    213.0<span class="pointtyp"> lakh</span>
                  </div>
                </div>
              </div>
              <div class="box4 fb_summery">
                <div class="blp2"></div>
                <div class="tp"></div>
                <div class="btm"></div>
                <div style={{ background: primarycolor }}>
                  <div
                    class="summerydetail hedclr"
                    style={{
                      background: primarycolor,
                      border: `1px solid ${secondarycolor}`,
                      boxShadow: `inset 0 0 5px ${secondarycolor}`,
                      color: secondaryfontcolor,
                    }}
                  >
                    <div class="summeryteam fs2">Team</div>
                    <div class="smplayer fs2">PL</div>
                    <div class="smtotal fs2">Points</div>
                    <div style={{ clear: "both" }}></div>
                  </div>
                  <div
                    class="summerybox tm_grp_all tm_grp_0"
                    style={{ border: `1px solid ${secondarycolor}` }}
                  >
                    <div
                      class="summerydetail oddclr rowclr"
                      style={{
                        border: `1px solid ${secondarycolor}`,
                        color: secondaryfontcolor,
                      }}
                    >
                      <div class="summeryteam fs2">BENGAL WARRIORS&nbsp;</div>
                      <div class="smplayer fs2" id="tplayercnt_84360">
                        1
                      </div>
                      <div class="smtotal fs2" id="totalcnt_84360">
                        17820.0<span class="pointtyp"> lakh</span>
                      </div>
                      <div style={{ clear: "both" }}></div>
                    </div>
                  </div>
                  <div
                    class="summerybox tm_grp_all tm_grp_0"
                    style={{ border: `1px solid ${secondarycolor}` }}
                  >
                    <div
                      class="summerydetail evnclr rowclr"
                      style={{
                        border: `1px solid ${secondarycolor}`,
                        color: secondaryfontcolor,
                      }}
                    >
                      <div class="summeryteam fs2">
                        CHENNAI SUPER KINGS&nbsp;
                      </div>
                      <div class="smplayer fs2" id="tplayercnt_75054">
                        1
                      </div>
                      <div class="smtotal fs2" id="totalcnt_75054">
                        16820.0<span class="pointtyp"> lakh</span>
                      </div>
                      <div style={{ clear: "both" }}></div>
                    </div>
                  </div>
                  <div
                    class="summerybox tm_grp_all tm_grp_0"
                    style={{ border: `1px solid ${secondarycolor}` }}
                  >
                    <div
                      class="summerydetail oddclr rowclr"
                      style={{
                        border: `1px solid ${secondarycolor}`,
                        color: secondaryfontcolor,
                      }}
                    >
                      <div class="summeryteam fs2">GUJRAT TITANS&nbsp;</div>
                      <div class="smplayer fs2" id="tplayercnt_84362">
                        1
                      </div>
                      <div class="smtotal fs2" id="totalcnt_84362">
                        26820.0<span class="pointtyp"> lakh</span>
                      </div>
                      <div style={{ clear: "both" }}></div>
                    </div>
                  </div>

                  {/* <div class="summerybox tm_grp_all tm_grp_2" style="text-align: center; padding: 18px 20px; display: none;">
                                <img src="/manage/images/background/superplwhite.png" style="width: 140px"></div>
                            </div> */}
                </div>
              </div>
              {/* <button onClick={themesubmit}>themesubmit</button> */}
            </>
          )}
          {/* ///////////////// theme2 /////////////////////// */}
          {theme == 2 && (
            <>
              <div class="overlay-1">
                <div class="content-1">
                  <div class="top-relative">
                    <div class="bbid">
                      <div
                        class="base-bid-outer"
                        style={{ background: secondarycolor }}
                      ></div>
                      <div
                        class="base-bid"
                        style={{
                          color: primaryfontcolor,
                          background: secondarycolor,
                          "--gradient-color-1": primarycolor_gc1,
                          "--gradient-color-2": primarycolor_gc2,
                        }}
                      >
                        <div
                          class="base-label"
                          style={{
                            borderBottom: `1px solid ${secondarycolor}`,
                          }}
                        >
                          Base Price
                        </div>
                        <div class="base-value">100000</div>
                      </div>
                    </div>

                    <div class="player">
                      <div
                        class="player-image"
                        style={{ border: `3px double ${secondarycolor}` }}
                      >
                        <img
                          src="https://t3.ftcdn.net/jpg/02/43/12/34/360_F_243123463_zTooub557xEWABDLk0jJklDyLSGl2jrr.jpg"
                          alt=""
                        />
                      </div>
                      <div
                        class="player-name"
                        style={{
                          color: primaryfontcolor,
                          background: secondarycolor,
                          "--gradient-color-1": primarycolor_gc1,
                          "--gradient-color-2": primarycolor_gc2,
                        }}
                      >
                        Virat
                      </div>
                      <div
                        class="player-name-outer"
                        style={{ background: secondarycolor }}
                      ></div>
                    </div>
                    <div class="currentbid">
                      <div id="currentteam" class="currentteam">
                        Rajasthan Royals
                      </div>
                      <div
                        class="current-bid-outer"
                        style={{ background: secondarycolor }}
                      ></div>
                      <div
                        class="current-bid"
                        style={{
                          color: primaryfontcolor,
                          background: secondarycolor,
                          "--gradient-color-1": primarycolor_gc1,
                          "--gradient-color-2": primarycolor_gc2,
                        }}
                      >
                        <div
                          class="current-bid-label"
                          style={{
                            borderBottom: `1px solid ${secondarycolor}`,
                          }}
                        >
                          Current Bid
                        </div>
                        <div class="current-bid-value">500</div>
                      </div>
                    </div>
                  </div>
                  <div class="player-bottom">
                    <div
                      class="player-detail"
                      style={{
                        color: primaryfontcolor,
                        background: secondarycolor,
                        "--gradient-color-1": primarycolor_gc1,
                        "--gradient-color-2": primarycolor_gc2,
                      }}
                    >
                      <div
                        class="spec"
                        style={{ borderRight: `1px solid ${secondarycolor}` }}
                      >
                        RH Bat
                      </div>
                      <div
                        class="spec2"
                        style={{ borderRight: `1px solid ${secondarycolor}` }}
                      >
                        City Jodhpur
                      </div>
                      <div class="age">Age 23</div>
                    </div>
                  </div>

                  <div class="hamm">
                    <img class="hammer" src="images/hammer.png" alt="" />
                  </div>
                  <div class="sold-d">
                    <div class="sold-detail">
                      <div>
                        <img src="images/soldteam.png" alt="" />
                      </div>
                      <div class="sold-to">
                        <span class="sold-p-name"> John Doe</span>
                        <span class="sold-t-name"> Sold to KKR</span>
                      </div>
                      <div class="sold-point">23.75 Cr</div>
                    </div>
                    <div class="sold-detail-outer"></div>
                  </div>
                  <div class="unsold-d">
                    <div class="unsold-detail">
                      <div class="unsold-to">
                        <span class="unsold-p-name"> John Doe</span>
                      </div>
                      <div class="unsold-label">
                        <img src="images/UNSOLDstamp.png" alt="" />
                      </div>
                    </div>
                    <div class="unsold-detail-outer"></div>
                  </div>
                </div>
                <div class="content-2">
                  <div class="header-main">
                    <div
                      class="header"
                      style={{
                        color: primaryfontcolor,
                        "--gradient-color-1": primarycolor_gc1,
                        "--gradient-color-2": primarycolor_gc2,
                        background: secondarycolor,
                      }}
                    >
                      <div>Teams</div>
                      <div>Points Rem</div>
                      <div>Player</div>
                    </div>
                    <div
                      class="header-outer"
                      style={{ background: secondarycolor }}
                    ></div>
                  </div>
                  <div class="header-items">
                    <div
                      class="item1"
                      style={{
                        color: primaryfontcolor,
                        "--gradient-color-1": primarycolor_gc1,
                        "--gradient-color-2": primarycolor_gc2,
                        border: `1px solid ${secondarycolor}`,
                      }}
                    >
                      <div>CSK</div>
                      <div
                        class="t-point"
                        style={{ background: secondarycolor }}
                      >
                        20000
                      </div>
                      <div class="t-player">2</div>
                    </div>
                    <div
                      class="item2"
                      style={{
                        color: primaryfontcolor,
                        "--gradient-color-1": primarycolor_gc1,
                        "--gradient-color-2": primarycolor_gc2,
                        border: `1px solid ${secondarycolor}`,
                      }}
                    >
                      <div>KKR</div>
                      <div
                        class="t-point"
                        style={{ background: secondarycolor }}
                      >
                        30000
                      </div>
                      <div class="t-player">3</div>
                    </div>
                    <div
                      class="item3"
                      style={{
                        color: primaryfontcolor,
                        "--gradient-color-1": primarycolor_gc1,
                        "--gradient-color-2": primarycolor_gc2,
                        border: `1px solid ${secondarycolor}`,
                      }}
                    >
                      <div>RR</div>
                      <div
                        class="t-point"
                        style={{ background: secondarycolor }}
                      >
                        50000
                      </div>
                      <div class="t-player">6</div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* ////////////////// theme 3 /////////////////////////////// */}

          {theme == 3 && (
            <>
              <main class="main-div">
                {activeScreen === "screen1" && (
                  <>
                    <div className="playersbio-section">
                      <section id="section2" class="player-sec">
                        <div class="main-section">
                          <div
                            class="team-player"
                            style={{
                              background: `linear-gradient(135deg, ${sc1_sec1_gc1}, ${sc1_sec1_gc2}, ${sc1_sec1_gc3})`,
                            }}
                          >
                            <div>
                              <img
                                class="logo-image"
                                src={teamlogo}
                                alt="image of logo"
                              />
                              <div
                                class="player-no-div"
                                style={{ background: sc1_plno_bg }}
                              >
                                <div
                                  class="player-no2"
                                  style={{ color: primaryfontcolor }}
                                >
                                  PLAYER NO{" "}
                                  <span style={{ color: sc1_plno_font }}>
                                    105
                                  </span>
                                </div>
                              </div>
                              <p
                                class="auction-year"
                                style={{ color: primaryfontcolor }}
                              >
                                PLAYER AUCTION <span>2024</span>
                              </p>
                            </div>
                            <div
                              class="gap-div"
                              style={{ background: sc1_plborder }}
                            ></div>
                            <div
                              class="players-photos"
                              style={{ background: sc1_plborder }}
                            >
                              <img
                                class="player-img"
                                src={playerimg}
                                alt="photo of the player"
                              />
                            </div>
                          </div>

                          <div class="player" style={{ background: sc1_sec2 }}>
                            <h1
                              class="team-name"
                              style={{ color: primaryfontcolor }}
                            >
                              DEVEDIGA PREMEIR LEAGUE
                            </h1>
                            <div class="player-bio2">
                              <p
                                class="player-name2"
                                style={{ color: sc1_plnm_font }}
                              >
                                CHANDRAKANT DEVADIGA
                                <span
                                  class="player-place"
                                  style={{ color: primaryfontcolor }}
                                >
                                  KOTADAMAKKI
                                </span>
                                <div
                                  class="blank-div"
                                  style={{
                                    background: `linear-gradient(90deg, ${sc1_pldetail_gc1}, ${sc1_pldetail_gc2}, ${sc1_pldetail_gc3})`,
                                  }}
                                ></div>
                              </p>
                            </div>

                            <div class="player-description2">
                              <div class="player-div">
                                <div
                                  class="player-type"
                                  style={{
                                    color: primaryfontcolor,
                                    background: `linear-gradient(90deg, ${sc1_pldetail_gc1}, ${sc1_pldetail_gc2}, ${sc1_pldetail_gc3})`,
                                  }}
                                >
                                  ALL-ROUNDER{" "}
                                </div>
                              </div>
                              <div class="player-div">
                                <div
                                  class="play-pattern"
                                  style={{
                                    color: primaryfontcolor,
                                    background: `linear-gradient(90deg, ${sc1_pldetail_gc1}, ${sc1_pldetail_gc2}, ${sc1_pldetail_gc3})`,
                                  }}
                                >
                                  {" "}
                                  RIGHT{" "}
                                </div>
                              </div>
                              <div class="player-div">
                                <div
                                  class="mobile"
                                  style={{
                                    color: primaryfontcolor,
                                    background: `linear-gradient(90deg, ${sc1_pldetail_gc1}, ${sc1_pldetail_gc2}, ${sc1_pldetail_gc3})`,
                                  }}
                                >
                                  {" "}
                                  8088742505{" "}
                                </div>
                              </div>
                            </div>
                            <div class="primary-btn2">
                              <button
                                class="btn"
                                style={{
                                  color: sc1_bid_font,
                                  background: `linear-gradient(180deg, ${sc1_crbid_bg1}, ${sc1_crbid_bg2}, ${sc1_crbid_bg3})`,
                                }}
                              >
                                CURRENT BID <span class="bid-no">0</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </section>
                      <div className="custombtn-div">
                        <button
                          class={`screenbtn ${
                            isClicked
                              ? activeScreen === "screen1"
                                ? "active"
                                : "inactive"
                              : ""
                          }`}
                          onClick={() => handleClick("screen1")}
                        >
                          Screen 1
                        </button>

                        <button
                          class={`screenbtn ${
                            isClicked
                              ? activeScreen === "screen2"
                                ? "active"
                                : "inactive"
                              : ""
                          }`}
                          onClick={() => handleClick("screen2")}
                        >
                          Screen 2
                        </button>
                      </div>
                    </div>
                  </>
                )}

                {/* <section class="btn-section">
                         <div class="strip-btn">
                          <button id="showBtn" class="primary-btn onclickbtn" onclick="showHideStrip()">
                            On Click
                          </button>
                        
                          <button class="primary-btn submitbtn"  onclick="showHideTable()"> Submit</button>
                        </div>
                    
                        <div class="strip-btn">
                          <button class="primary-btn clickbtn" onclick="toggleSection('section1')">Click</button>
                          <button class="primary-btn clickBtn" onclick="toggleSection('section2')">Click Btn</button>
                        </div>  
                        
                        </section> */}

                {activeScreen === "screen2" && (
                  <>
                    <div className="stripdescription">
                      <section id="section1">
                        <div class="strip-section1">
                          <div class="bg-strip">
                            <video autoplay muted loop>
                              <source src={bgvideo} type="video/mp4" />
                              Your browser is not supported!
                            </video>
                          </div>
                          <div class="player-description">
                            <div
                              class="player-bio"
                              style={{ background: sc2_primary_bg }}
                            >
                              <div class="player-no-section">
                                <p
                                  class="player-no"
                                  style={{ color: sc2_plno_nm_font }}
                                >
                                  PLAYER NO <span>98</span>
                                </p>
                                <div
                                  class="player-image"
                                  style={{ background: sc2_plborder }}
                                >
                                  <img
                                    class="player-photo"
                                    src={playerimg}
                                    alt="photo1"
                                  />
                                </div>
                              </div>
                              <div
                                class="player-name"
                                style={{ color: sc2_plno_nm_font }}
                              >
                                RAVI DEVEDIGA{" "}
                                <span style={{ color: primaryfontcolor }}>
                                  BENGRE 2{" "}
                                </span>{" "}
                                <span style={{ color: primaryfontcolor }}>
                                  ALL-ROUNDER
                                </span>
                              </div>
                            </div>
                            <div
                              class="player-bid-description"
                              style={{ background: sc2_crbid_bg }}
                            >
                              <div
                                class="player-bid"
                                style={{ color: sc2_crbid_font }}
                              >
                                <span class="player-bid-current">
                                  CURRENT BID
                                </span>
                                <span class="player-bid-no">1</span>
                              </div>
                            </div>
                          </div>

                          <div class="table-section">
                            <table class="player-table">
                              <thead
                                style={{
                                  background: sc2_tbHead_bg,
                                }}
                              >
                                <th
                                  style={{ color: sc2_tbHead_row_font }}
                                  colspan="2"
                                >
                                  POINTS REMAINING
                                </th>
                              </thead>
                              <tbody>
                                <tr
                                  style={{
                                    color: primaryfontcolor,
                                    background: sc2_tbOdd_bg,
                                  }}
                                >
                                  <td>APPU POWER HITTERS</td>
                                  <td>16</td>
                                </tr>
                                <tr
                                  style={{
                                    color: sc2_tbHead_row_font,
                                    background: sc2_tbEven_bg,
                                  }}
                                >
                                  <td>MAHAGANAPATI POWER HITTERS</td>
                                  <td>8</td>
                                </tr>
                                <tr
                                  style={{
                                    color: primaryfontcolor,
                                    background: sc2_tbOdd_bg,
                                  }}
                                >
                                  <td>MURDESHWAR LEGENDS</td>
                                  <td>30</td>
                                </tr>
                                <tr
                                  style={{
                                    color: sc2_tbHead_row_font,
                                    background: sc2_tbEven_bg,
                                  }}
                                >
                                  <td>SHIVALINGESHWARA STRIKES</td>
                                  <td>10</td>
                                </tr>
                                <tr
                                  style={{
                                    color: primaryfontcolor,
                                    background: sc2_tbOdd_bg,
                                  }}
                                >
                                  <td>SSS SPORTS CLUB</td>
                                  <td>32</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </section>
                      <div className="custombtn-div">
                        <button
                          class={`screenbtn ${
                            isClicked
                              ? activeScreen === "screen1"
                                ? "active"
                                : "inactive"
                              : ""
                          } `}
                          onClick={() => handleClick("screen1")}
                        >
                          Screen 1
                        </button>

                        <button
                          class={`screenbtn ${
                            isClicked
                              ? activeScreen === "screen2"
                                ? "active"
                                : "inactive"
                              : ""
                          }`}
                          onClick={() => handleClick("screen2")}
                        >
                          Screen 2
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </main>
            </>
          )}
        </div>
      </div>

      {/* Add buttons container below */}
      <div className="action-buttons">
        <button className="download-btn" onClick={downloadcustomchanges}>
          Download Theme
        </button>
        <button className="apply-btn" onClick={() => themesubmit(theme)}>
          Apply Changes
        </button>
      </div>

      {/* Floating Overlay URL with copy button */}
      <div style={{ 
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        background: '#f5f5f5',
        padding: '8px 12px',
        borderRadius: '50px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
        maxWidth: '400px'
      }}>
        <span style={{
          fontWeight: 'bold',
          fontSize: '13px',
          color: '#0a1c41',
          marginRight: '5px'
        }}>
          Overlay link:
        </span>
        <input 
          type="text" 
          value={overlayUrl} 
          readOnly 
          style={{
            flex: 1,
            border: 'none',
            background: 'transparent',
            padding: '0 8px',
            outline: 'none',
            fontSize: '13px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: '200px'
          }}
        />
        <button 
          onClick={copyToClipboard}
          style={{
            background: '#0a1c41',
            color: 'white',
            border: 'none',
            borderRadius: '50px',
            width: '36px',
            height: '36px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            marginLeft: '8px'
          }}
          title="Copy overlay URL"
          onMouseOver={e => e.currentTarget.style.background = '#00ffdf'}
          onMouseOut={e => e.currentTarget.style.background = '#0a1c41'}
        >
          <FontAwesomeIcon icon={faCopy} />
        </button>
      </div>
    </div>
  );
}
